import { get } from 'lodash'
import React, { useState, useRef } from 'react'
import { Select } from 'components/Select'
import { useCountriesQuery } from 'types/graphql-generated'
import { getCustomNoOptionText } from './utils'

const EMPTY_ARRAY = []

type Value = {
  title?: string
  isoCode?: string
}

interface CountrySearchLegacyProps {
  value?: Value
  onChange: (value: Value) => void
  isError?: boolean
  hint?: string
  isRequiredField?: boolean
}

export const CountrySearchLegacy: React.FC<CountrySearchLegacyProps> = ({
  value,
  onChange,
  isError,
  hint,
  isRequiredField = false,
  ...rest
}) => {
  const isInitialLoad = useRef(true)
  const [inputValue, setInputValue] = useState(value?.isoCode)
  const [selectedValue, setSelectedValue] = useState(value)

  const { data, loading: isLoading } = useCountriesQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-first',
    skip: !inputValue && !value?.isoCode,
    variables: {
      search: inputValue ?? value?.isoCode,
    },
    onCompleted: (completeData) => {
      if (isInitialLoad.current) {
        if (completeData.countries.length && value?.isoCode) {
          const matchingCountry = completeData.countries.find(
            ({ isoCode }) => isoCode === value.isoCode
          )
          if (matchingCountry) {
            setSelectedValue(matchingCountry)
          }
        }
        isInitialLoad.current = false
      }
    },
  })

  const countries = get(data, 'countries', EMPTY_ARRAY)
  const customNoOptionsText = getCustomNoOptionText({
    inputValue,
    isLoading,
    options: countries,
    label: 'country',
  })
  return (
    <Select
      hasHint
      label={isRequiredField ? 'Country*' : 'Country'}
      autocomplete={false}
      isError={isError}
      hint={hint}
      isSearchable
      value={selectedValue}
      getOptionLabel={(item) => item.title}
      getOptionValue={(item) => item.isoCode}
      customNoOptionsText={customNoOptionsText}
      options={countries}
      onInputChange={setInputValue}
      onChange={(newValue: Value) => {
        onChange(newValue)
        setSelectedValue(newValue)
      }}
      {...rest}
    />
  )
}
